import { render, staticRenderFns } from "./ChooseStationField.vue?vue&type=template&id=3b53b4ba"
import script from "./ChooseStationField.vue?vue&type=script&lang=js"
export * from "./ChooseStationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports